// extracted by mini-css-extract-plugin
module.exports = {"contactForm":"ContactDetails__contactForm__3jAKK"};